import AutomotiveRunsModal from "./AutomotiveRunsModal";

/** Vehicle Market unified grid — production run history modal. */
const VehicleMarketRunsModal = (props) => <AutomotiveRunsModal {...props} />;

export default VehicleMarketRunsModal;
